import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('productGroup/getItems'),
      this.$store.dispatch('productType/getItems'),
      this.$store.dispatch('domain/getItems')
    ]);
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'PrintTemplate',
    returnTo: 'PrintTemplates'
  }),
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
